// libs
import 'lightgallery';
import $ from 'jquery';
import '../Design/sass/app.sass';

// size() is needed for tilesGallery.js
$.fn.size = function() {
  return $(this).length;
};
import './lib/tilesGallery.js';

import './components/modal.js';
import './components/mobileNav.js';
import './components/sliders.js';
import './components/hero.js';
import './components/touchpoints.js';
import './components/modalContactRequest.js';
import './components/campaign.js';

import AOS from 'aos';
AOS.init();
window.addEventListener('load', AOS.refresh);

import SplashScreenHandler from './components/splashScreenHandler.js';
var splashScreen = $('#splashscreen');
if (splashScreen.length) {
  new SplashScreenHandler({ container: splashScreen });
}

import ContactFormHandler from './components/contactFormHandler.js';
var contactForm = $('#contact-form');
if (contactForm.length) {
  new ContactFormHandler({ container: contactForm });
}

import ScrollAnimation from './components/scrollAnimation.js';


var scrollAnimation;

function resetScrollAnimation() {
  if (scrollAnimation && scrollAnimation._animationId) {
    cancelAnimationFrame(scrollAnimation._animationId);
  }

  $('.packaging').each((i, el) => {
    scrollAnimation = new ScrollAnimation({ container: $(el).parent().parent()});
  });

  $('.non-sticky video').on('ended', function() {
    $(this).nextAll('.js-play-again').show();
  });
}

$('.packaging').each((i, el) => {
  scrollAnimation = new ScrollAnimation({ container: $(el).parent().parent()});
});

var isMobile = /Android|iPhone|iPod|iPad/i.test(navigator.userAgent);

if (!isMobile) {
  $(window).on('resize', function() {
	  resetScrollAnimation();
  });	
}

$(window).on('orientationchange', function() {
  setTimeout(function() {
    resetScrollAnimation();
  }, 500);
});

import SliderVideo from './components/sliderVideo';

$('.section_slider video').each((i, el) => {
  if (i === 0) {
    new SliderVideo({ video: $(el)});
  }
});

$('.slider').on('afterChange', function() {
  var video = $('.slick-current video');
  if (video.length > 0) {
    video[0].play();
  }
});

$('.slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  var video = $(slick.$slides[nextSlide]).find('video');
  if (video.length > 0) {
    video[0].currentTime = 0;
  }
  $('.js-play-again').hide();
});

$('.js-play-again').click(function() {
  var video = $(this).prev()[0];
  video.currentTime = 0;
  video.play();
  return false;
});

$('.slider video, .non-sticky video').on('ended', function() {
  $(this).nextAll('.js-play-again').show();
});

import Video from './components/video';
var heroVideo = $('.section_details').find('video');
if (heroVideo.length > 0) {
  new Video({ video: $(heroVideo)});
}

import svg4everybody from 'svg4everybody';
import Masonry from 'masonry-layout/dist/masonry.pkgd.min';

svg4everybody();

import lightbox from 'lightbox2';

$(function() {
  lightbox.option({
    'resizeDuration': 200,
    'wrapAround': true,
    'showImageNumberLabel': false,
    'alwaysShowNavOnTouchDevices': true
  });
  var $lg = $('.tiles');
  $lg.tilesGallery({
    margin: 0,
    height: 652,
    reloadOnResize: false,
    tileMinHeight: 75,
  });
});

$('[data-modal="modal__3D"]').on('click',function() {
  $('.js-gallery .js-modalmasonry').eq(0).trigger('click');
  return false;
});

var grid = document.querySelector('.js-gallery');
if (grid != null) {
  new Masonry(grid, {
    itemSelector: '.js-modalmasonry'
  });
}

import FullscreenFeatureGallery from './components/fullscreenFeatureGallery.js';
$('.section_articles').each((i, el) => {
  new FullscreenFeatureGallery({ container: $(el) });
});

import ContactRequestFormHandler from './components/contactRequestFormHandler.js';
$('.contact-request.modal').each((i, el) => {
  new ContactRequestFormHandler({ container: $(el) });
});

import ApplicantFormHandler from './components/applicantFormHandler.js';
$('.applicant-form-section').each((i, el) => {
  new ApplicantFormHandler({ container: $(el) });
});

import Touchpoints from './components/touchpoints.js';

var touchpointsList = Array.from(document.querySelectorAll('.touchpoints'));
touchpointsList.forEach(function(touchpointsItem) {
  new Touchpoints({ container: touchpointsItem });
});
